import {ModuleView} from './ModuleView';

export {Module} from './Module';


export const moduleRegistrations = {
    'Module': ModuleView,
};
